import lightGallery from "lightgallery";
import lgThumbnail from "lightgallery/plugins/thumbnail";
import lgZoom from "lightgallery/plugins/zoom";

$(document).on("turbolinks:load", () => {
  if ($("body").hasClass("developments") && $("body").hasClass("show")) {
    lightGallery(document.getElementById("lg-images"), {
      plugins: [lgZoom, lgThumbnail],
      mode: "lg-slide",
      speed: 500,
      loop: false,
      slideEndAnimation: false,
    });

    const openImagesGallery = () => {
      $("#lg-images img:first").trigger("click");
    };

    $(".gallery-wrapper .card-cover").on("click", (event) => {
      event.preventDefault();
      openImagesGallery();
    });
  }
});
